import { Injectable } from "@angular/core";
import {HttpBackend, HttpClient} from '@angular/common/http';
import { InitiateTransaction } from "./initiate-transaction";
import {DonationInfo} from "../donation/donation-info/donation-request";

const host = "https://pg.ekpay.gov.bd/";
@Injectable()
export class DonationService {

    private http: HttpClient;
    constructor(handler: HttpBackend) {
      this.http = new HttpClient(handler);
    }
    //https://ekpay.gov.bd/

    initiate(data : DonationInfo) : any {
      const jsonData = JSON.stringify(data);
      return this.http.post(host + "/donation/payment-initiate", data, {observe: 'response'});
    }

  checkStatus(trxid) : any {
    return this.http.get(host + "/donation/transaction-status?trxId="+ trxid, {observe: 'response'});
  }

  donationStatus(trxid) : any {
    return this.http.get(host + "/donation/donation-status?trxId="+ trxid, {observe: 'response'});
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/Donation.Services.ts